module.exports = __webpack_public_path__ + "static/media/profileImage.8e8c379b.png";